import type { SectionEditorSettings, SettingsComponentProps } from '~/clc/features/theming/types';
import type { HubHeader } from '~/clc/features/theming/constants';
// import { useState } from 'react';
import {
  RadioButton,
  RadioButtonGroup,
  RadioGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  // NumberField,
  Divider,
  Body,
  Span,
} from '@workramp/ui';
import StringUtils from '~/common/string-utils';
// import { useDebouncedCallback } from '~/hooks';
import { CLCHubSectionTypes } from '~/clc/features/theming/constants';
import { ColorSettings } from '../../../admin/components/sections/colors';
import {
  CustomCSSSetting,
  // FontPickerWithDefaultSetting,
  MenuSetting,
  SettingsSidebarSubSection,
} from '../../../admin/components';
import { CollapsibleSetting } from '../../../admin/components/ThemingEditorPage/SettingsSidebar/CollapsibleSetting';

const { APP_CONSTANTS } = window;

interface NavigationSettingsProps extends SettingsComponentProps {
  sectionThemeSettings: HubHeader;
}

const firstGroupLogoOptions = APP_CONSTANTS.CUSTOMER_LEARNING_CLOUD_THEMING.LOGO_OPTIONS.filter((i) => i === 'default');
const secondGroupLogoOptions = APP_CONSTANTS.CUSTOMER_LEARNING_CLOUD_THEMING.LOGO_OPTIONS.filter((i) => i === 'hide');

const NavigationSettings = ({ sectionThemeSettings, onChange, mixpanelInfo }: NavigationSettingsProps) => {
  // const [cornerRadius, setCornerRadius] = useState(sectionThemeSettings.navigation.cornerRadius);

  const onNavigationSettingChange = (propName: string, propVal: any) => {
    onChange({ navigation: { [propName]: propVal } });
  };

  // TODO: word has it we want this some day
  // const debouncedOnCornerRadiusOnChange = useDebouncedCallback(() =>
  //   onNavigationSettingChange('cornerRadius', cornerRadius),
  // );
  // const onCornerRadiusChange = (val: number) => {
  //   setCornerRadius(val);
  //   debouncedOnCornerRadiusOnChange();
  // };

  return (
    <>
      <SettingsSidebarSubSection>
        <MenuSetting
          activeProducts={['academy', 'community']}
          label="Menu"
          value={sectionThemeSettings.navigation.menuItems}
          mixpanelInfo={mixpanelInfo}
          onChange={(links) =>
            onNavigationSettingChange(
              'menuItems',
              links.map(({ label, href, openInNewTab }) => ({ label, href, openInNewTab })),
            )
          }
        />
        <RadioGroup
          label="Menu position"
          value={sectionThemeSettings.navigation.menuPosition}
          onChange={(v: string) => onNavigationSettingChange('menuPosition', v)}
        >
          <RadioButtonGroup>
            {APP_CONSTANTS.CUSTOMER_LEARNING_CLOUD_THEMING.ALIGNMENTS.map((alignment) => (
              <RadioButton
                key={alignment}
                isBlock
                aria-label={StringUtils.getCapitalizedWordsFromUnderscoredString(alignment, true)}
                leadingIconName={`${alignment}:regular`}
                value={alignment}
              />
            ))}
          </RadioButtonGroup>
        </RadioGroup>
        <Switch
          isSelected={sectionThemeSettings.navigation.showDivider}
          onChange={() => onNavigationSettingChange('showDivider', !sectionThemeSettings.navigation.showDivider)}
        >
          Show divider
        </Switch>
        {/* <Select
          title="Menu item type"
          label="Menu item type"
          selectedKey={sectionThemeSettings.navigation.menuItemType}
          onSelectionChange={(t: string) => onNavigationSettingChange('menuItemType', t)}
          placeholder="Select an option..."
        >
          {APP_CONSTANTS.CUSTOMER_LEARNING_CLOUD_THEMING.MENU_ITEM_TYPES.map((itemType) => (
            <Option key={itemType}>{StringUtils.getCapitalizedWordsFromUnderscoredString(itemType, true)}</Option>
          ))}
        </Select> */}
        {/* <NumberField label="Corner radius" value={cornerRadius} onChange={onCornerRadiusChange} /> */}
      </SettingsSidebarSubSection>

      <Divider />

      <SettingsSidebarSubSection>
        <Select
          title="Logo"
          label="Logo"
          selectedKey={sectionThemeSettings.navigation.logo}
          onSelectionChange={(l: string) => onNavigationSettingChange('logo', l)}
          placeholder="Select an option..."
        >
          {firstGroupLogoOptions.map((logo) => (
            <Option key={logo}>{`${StringUtils.getCapitalizedWordsFromUnderscoredString(logo, true)} logo`}</Option>
          ))}
          <OptionGroup title={null}>
            {secondGroupLogoOptions.map((logo) => (
              <Option key={logo}>{`${StringUtils.getCapitalizedWordsFromUnderscoredString(logo, true)} logo`}</Option>
            ))}
          </OptionGroup>
        </Select>
      </SettingsSidebarSubSection>

      <Divider />

      <CollapsibleSetting
        iconName="colors:regular"
        settingName="Colors"
        description={
          <Body level="md">Override theme defaults. You can edit your default colors in theme settings.</Body>
        }
      >
        <ColorSettings
          isLockable
          colorOptions={sectionThemeSettings.colors}
          onLockChange={(propName: string, propVal: Record<string, any>) =>
            onChange({ colors: { [propName]: propVal } })
          }
          onChange={(propName: string, val: string) => {
            onChange({ colors: { [propName]: { value: val } } });
          }}
        />
      </CollapsibleSetting>

      {/* <Divider />

      <CollapsibleSetting
        iconName="typography:regular"
        settingName="Typography"
        description={
          <Body level="md">Override theme defaults. You can edit your default typography in theme settings.</Body>
        }
      >
        <FontPickerWithDefaultSetting
          label="Heading"
          onLockPress={() =>
            onChange({ typography: { heading: { isLocked: !sectionThemeSettings.typography.heading.isLocked } } })
          }
          isLocked={sectionThemeSettings.typography.heading.isLocked}
          onChange={(t: string) => onChange({ heading: { value: t } })}
        />
        <FontPickerWithDefaultSetting
          label="Body"
          onLockPress={() =>
            onChange({ typography: { body: { isLocked: !sectionThemeSettings.typography.body.isLocked } } })
          }
          isLocked={sectionThemeSettings.typography.body.isLocked}
          onChange={(t: string) => onChange({ body: { value: t } })}
        />
      </CollapsibleSetting> */}

      <Divider />

      <CollapsibleSetting
        iconName="html:regular"
        settingName="Custom CSS"
        description={
          <Body level="md">
            Add custom css styles to <Span weight="bold">this section only</Span>
          </Body>
        }
      >
        <CustomCSSSetting
          value={sectionThemeSettings.navigation.custom_css}
          label="custom css"
          hideLabel
          onChange={(custom_css: string) => onNavigationSettingChange('custom_css', custom_css)}
        />
      </CollapsibleSetting>
    </>
  );
};

export const NavigationSectionEditorSettings: SectionEditorSettings = {
  type: CLCHubSectionTypes.NAVIGATION,
  schemaKey: null,
  name: 'Navigation',
  iconName: 'layout-top:regular',
  settings: NavigationSettings,
  description: 'Make changes to your navigation. Changes here will be shared across all your pages.',
};
